import { buildBrandSwitchUrl } from '~/routing/brandSwitch';
import { paths } from '~/routing/routes';

/**
 * Leave HLX for the provider's own MedCredVault dashboard (the same destination
 * as the side nav's MedCredVault link). A full navigation, because the
 * destination is another origin.
 */
export const returnToMedCredVault = () => {
  window.location.assign(buildBrandSwitchUrl('mcv', paths.vault.dashboard));
};
